export default __webpack_public_path__ + "media/vendors/google_play_download-ceae6df4.svg";